import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { axiosClient } from '../../../core/axios-client'

const fetchCapabilities = createAsyncThunk('fetchCapabilities', async () => {
  const response = await axiosClient.get('/companies/selected/capabilities')
  return response.data
})

const initialState = {
  // null, а не пустой массив: «ещё не знаем» и «не доступен ни один модуль» -
  // разные вещи. Пока не знаем, интерфейс показывает всё; пустой массив
  // означал бы пустое меню на каждой загрузке страницы
  modules: null,
  permissions: null,
  // null - роли нет: сотрудника отключили или выбранный парк больше не его
  role: null,
  // Тип бизнеса и модули, которых у компании нет: приходят с бэкенда, null - не отдаёт
  business_profile: null,
  modules_offered: null,
  plan: null,
  limits: {},
  usage: {},
  isLoaded: false,
}

export const slice = createSlice({
  name: 'capabilities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCapabilities.fulfilled, (state, { payload }) => {
      state.modules = payload.modules || []
      state.plan = payload.plan || null
      // null, пока бэкенд не отдаёт права: см. core/helpers/access.js
      state.permissions = Array.isArray(payload.permissions) ? payload.permissions : null
      state.role = payload.role || null
      state.business_profile = payload.business_profile || null
      state.modules_offered = Array.isArray(payload.modules_offered) ? payload.modules_offered : null
      state.limits = payload.limits || {}
      state.usage = payload.usage || {}
      state.isLoaded = true
    })
    builder.addCase(fetchCapabilities.rejected, (state) => {
      // Права не приехали - показываем всё. Спрятать лишний раздел не страшно,
      // он всё равно закрыт на бэкенде; а вот пустое меню из-за сетевой
      // икоты выглядит как сломанная система
      state.modules = null
      state.permissions = null
      state.role = null
      state.business_profile = null
      state.modules_offered = null
      state.isLoaded = true
    })
  },
})

export { fetchCapabilities }

export default slice.reducer
